module.exports = __webpack_public_path__ + "static/martal-hardwoord-belgium-47309d6e941113a8d47d53eff602b18f.jpg";